import { useMemo } from 'react';
import { getBillModeOptions, getDefaultBillMode, getDefaultIssueDate, normalizeEffectiveDate } from "./BillingDate.utils";
import { useIoContext } from "../../../providers/IoContext";
export const useBillingModeData = _ref => {
  let {
    invoiceDateInfo,
    effectiveDate = null,
    earliestBillableDate
  } = _ref;
  const {
    getNow
  } = useIoContext();
  const billModeOptions = useMemo(() => getBillModeOptions(getNow(), effectiveDate, invoiceDateInfo), [effectiveDate, invoiceDateInfo]);
  const defaultMode = useMemo(() => getDefaultBillMode(billModeOptions, invoiceDateInfo), [billModeOptions, invoiceDateInfo]);
  const defaultIssueDate = useMemo(() => getDefaultIssueDate(defaultMode, invoiceDateInfo, getNow(), normalizeEffectiveDate(effectiveDate), earliestBillableDate), [defaultMode, invoiceDateInfo, effectiveDate, earliestBillableDate]);
  return {
    billModeOptions,
    defaultMode,
    defaultIssueDate
  };
};